import root from "./component-library264.mjs";
import toString from "./component-library277.mjs";
var reTrimStart = /^\s+/;
var nativeParseInt = root.parseInt;
function parseInt(string, radix, guard) {
  if (guard || radix == null) {
    radix = 0;
  } else if (radix) {
    radix = +radix;
  }
  return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
}
export {
  parseInt as default
};
